<input
  #fileInput
  class="hidden"
  type="file"
  [multiple]="multiple()"
  [accept]="acceptString()"
  (change)="onFileInputChange($event)"
  [disabled]="control?.disabled"
  [attr.id]="id()"
  [attr.data-testid]="id()"
/>
